<div
  class="slow-hint"
  role="status"
  aria-live="polite"
  [class.is-visible]="visible()"
  [attr.aria-hidden]="visible() ? null : 'true'"
>
  <app-mobile-navigation-loader></app-mobile-navigation-loader>
  <span class="slow-hint__text">
    <ng-container *ngIf="!showCancel()">
      {{ 'app.nav.slowConnection.hint' | translate }}
    </ng-container>
    <ng-container *ngIf="showCancel()">
      {{ 'app.nav.slowConnection.longer' | translate }}
    </ng-container>
  </span>
  <button
    *ngIf="showCancel()"
    type="button"
    class="slow-hint__cancel"
    (click)="onCancel()"
  >
    {{ 'app.nav.slowConnection.cancel' | translate }}
  </button>
</div>
